import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import axios from 'axios';

import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';



//
import Layout from '../../../component/Layout/Layout';
import Card from '../../../component/Layout/theme/card';
import PageChange from '../../../pageChange';



//
import { GetMethod } from '../../../helper/Api';
import toast from "react-hot-toast";


function EditVideo() {

    const { token, login } = useSelector((item) => item.user);
    const [showConvert, setShowConvert] = useState(true)
    const [errorSub, setErrorSub] = useState()

    const [progressConvert, setProgressConvert] = useState(0);

    const { id, index } = useParams();
    var { t } = useTranslation();


    const [isDataLoad, SetIsDataLoad] = useState(false);
    const [video, SetVideo] = useState("");

    const [newVideo, SetNewVideo] = useState(null);
    const [convetsVideo, setConverVideo] = useState(null);


    const [data, setData] = useState()
    const [disableButton, setDisableButton] = useState(false)

    const [progress, setProgress] = useState(0);
    const [isProgress, setIsProgress] = useState(false)
    var durationConvert = 0;




    useEffect(() => {
        document.title = t("create_augmented_reality");
        if (login === false) {
            window.location.href = "/login"
        }
        getData()
    }, [])

    const getData = async () => {
        var url = `/api/nft/edit/${id}`;
        const res = await GetMethod({ url: url, token: token });

        if (res.status === "success") {
            SetVideo(res.data.video[index])
            setData(res.data)
            SetIsDataLoad(true)
        }
    }







    const ffmpeg = createFFmpeg({
        progress: (e) => {
            if (e.duration) {
                durationConvert = e.duration
            }
            if (e.time) {
                var fin = Math.round(((e.time + durationConvert) / durationConvert * 100) - 100)
                setProgressConvert(fin)
                setTimeout(() => {
                    document.getElementById("progressBarConvert").setAttribute("style", "width: " + fin.toString() + "%;");
                }, 100);
            }
        },
        log: true,
    });

    function blobToFile(theBlob, fileName) {
        return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
    }



    async function convertUserVideo(video) {
        await ffmpeg.load();
        ffmpeg.FS('writeFile', video.name, await fetchFile(video));
        await ffmpeg.run('-i', video.name, '-c:v', 'libx264', '-vf', 'scale=720:-2,format=yuv420p', '-c:a', 'copy', '-movflags', '+faststart', 'output.mp4');
        const data = ffmpeg.FS('readFile', 'output.mp4');
        const blob = new Blob([data.buffer], { type: 'video/mp4' })
        var file = blobToFile(blob, "final.mp4");
        return file;
    }


    const submitForm = async () => {
        if (newVideo === null) {
            toast.error(t("fill_in_video_validation"))
        }
        else {
            setShowConvert(false);

            document.getElementById("video_converts").disable = true;
            var videoConverted = await convertUserVideo(newVideo);
            setConverVideo(newVideo)

            setDisableButton(true)

            const formData = new FormData();
            formData.append("video", videoConverted);

            var url = `${process.env.REACT_APP_SERVER}/api/nft/edit/video/${id}?query:${index}`;
            setIsProgress(true)
            setProgress(1)
            try {
                await axios.put(url, formData, {
                    headers: {
                        Authorization: "ArNew " + token,
                    },
                    onUploadProgress: function (progressEvent) {
                        var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setProgress(percentCompleted);
                        document.getElementById("progressBar").style.width = percentCompleted.toString() + "%";
                    }
                }).then((result) => {

                    if (result.data.status === "success") {
                        setIsProgress(false)
                        toast.error(t("mission_was_successful"));
                        window.history.back();
                        setTimeout(() => {
                            window.history.back();
                        }, 500);
                    }

                    window.history.back();

                })
            } catch (error) {
                console.log(error.response);
                toast.error(error.response?.data?.msg);
                setTimeout(() => {
                    window.history.back();
                }, 5000);
            } finally {
                setDisableButton(false)
            }
        }
    };

    return (
        <>
            {
                isDataLoad
                    ?
                    (
                        <Layout>
                            <Card >
                                <div className='p-5 mb-24 space-y-3 bg-white rounded-lg shadow-md'>

                                    <div>
                                        <video controls className='!min-h-[1rem] w-60 h-60'>
                                            <source src={`${process.env.REACT_APP_SERVER}/uploads/${data.users.username}/video/${video}`} />
                                        </video>
                                    </div>

                                    <div className='flex flex-col items-center gap-2'>
                                        <div className="relative w-[120px] h-[100px] border-dashed border-2 rounded-lg border-gray-400 flex justify-center items-center" >
                                            <div>
                                                {
                                                    newVideo === null
                                                        ?
                                                        <img src={process.env.REACT_APP_ADDRESS + "/img/cloud-upload-regular-240.png"} className="absolute inset-0 w-full h-full !min-h-[1rem] object-contain" />
                                                        :
                                                        <video className='absolute !min-h-[1rem] inset-0 w-full h-full' controls style={{ objectFit: 'contain' }}>
                                                            <source src={URL.createObjectURL(newVideo)} />
                                                        </video>
                                                }
                                            </div>
                                            <input
                                                type="file"
                                                value={undefined}
                                                accept="video/*"
                                                id="video_converts"
                                                className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                                                onChange={(e) => SetNewVideo(e.target.files[0])}
                                            />
                                        </div>
                                        <p className='text-sm font-normal text-gray-800'>{t("Upload_a_new_video")}</p>
                                    </div>



                                    {showConvert ? (
                                        <div className="relative flex rounded-lg ">

                                            <button
                                                className="w-full h-10 mt-2 text-white bg-blue-500 rounded-lg"
                                                type="submit"
                                                onClick={() => submitForm()}
                                                disabled={disableButton ? true : false}
                                            // onKeyPress={(e) => enterKeyPress(e)}
                                            >
                                                {t("edit")}
                                            </button>



                                            {/* <button onClick={() => saveAllImage()} className="w-full p-2 text-white bg-green-500 rounded-lg ">{t("add")}</button> */}
                                        </div>
                                    ) : (


                                        isProgress ? (
                                            <div role="status">
                                                <svg className="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                </svg>
                                                <span className="p-2">{t("uploading")}</span>
                                                <div className="my-4">
                                                    <span id="progress" className="text-center" dir="rtl"></span>
                                                    {
                                                        progress !== 0 && (
                                                            <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                                                                <div id="progressBar" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progress}%</div>
                                                            </div>
                                                        )}
                                                </div>
                                                <div className="flex flex-col justify-center h-10 text-center text-white bg-blue-100 rounded-lg">
                                                    {t("edit")}
                                                </div>

                                            </div>
                                        ) :
                                            <div role="status">
                                                <svg className="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                </svg>
                                                <span className="p-2">{t("convertVideo")}</span>
                                                <div className="my-4">
                                                    {
                                                        progressConvert !== 0 && (
                                                            <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                                                                <div id="progressBarConvert" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progressConvert}%</div>
                                                            </div>
                                                        )
                                                    }

                                                </div>
                                                <div className="flex flex-col justify-center h-10 text-center text-white bg-blue-100 rounded-lg">
                                                    {t("edit")}
                                                </div>
                                            </div>
                                    )}

                                    <p>
                                        {errorSub}
                                    </p>




                                </div>

                            </Card>

                        </Layout>

                    )
                    :
                    <PageChange />
            }

        </>
    )
}

export default EditVideo
